<template>
  <div>
    <GenericField
      :value="selectedEntityUuid"
      :field="field"
      :items="computedApiItems"
      :classes="classes"
      :clearable="!readOnly"
      @input="updateValue"
    />
  </div>
</template>

<script>
import GenericField from '@/components/dynamic/form/templates/GenericField.vue';
import { requests } from '@/mixins/requests.js';

export default {
  components: { GenericField },
  props: {
    field: {
      type: Object,
      default: () => ({})
    },
    selectedEntityUuid: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: () => []
    },
    classes: {
      type: String,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      apiItems: [],
      isLoading: false
    };
  },
  computed: {
    computedApiItems () {
      return this.apiItems.reduce((acc, item) => {
        acc.push({
          value: item[this.field?.itemValue || 'uuid'],
          text: item[this.field?.itemText || 'name']
        });
        return acc;
      }, []);
    }
  },
  async mounted () {
    if (this.readOnly) {
      this.apiItems = this.items;
    } else {
      await this.getData();
    }

    if (this.selectedEntityUuid) {
      this.$emit('init-entity', this.apiItems.find(item => item.uuid === this.selectedEntityUuid));
    }
  },
  methods: {
    async getData () {
      this.isLoading = true;
      try {
        const response = await requests.getEntityItems({ key: this.field.key });

        if (!response.success || !response.data) {
          this.$store.commit('setSnackbar', { text: 'Erreur lors de la récupération des entités', color: 'error' });
          return;
        }
        this.apiItems = response.data;

        this.$emit('entity-response', this.apiItems);
      } catch (error) {
        this.$store.commit('setSnackbar', { text: 'Erreur lors de la récupération des entités', color: 'error' });
      } finally {
        this.isLoading = false;
      }
    },
    updateValue (value) {
      this.$emit('input', value, this.field.name);

      if (value) {
        this.setSelectedEntity(value);
      }
    },
    setSelectedEntity (value) {
      this.$emit('selected-entity', this.apiItems.find(item => item.uuid === value));
    }
  }
};
</script>
